import BackButton from "../../../components/BackButton/BackButton";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useFetch } from "../../../utils/useFetch";
import { settlement_list_url, settlement_url } from "../../../api/urls";
import { CheckIcon, DownloadCloud } from "lucide-react";
import moment from "moment";
import { areYouSure } from "../../../utils/areYouSure";
import { api } from "../../../api/api";
import { useToast } from "../../../components/Toast";
import Loading from "../../../components/Loading/Loading";

const SettleOrderDetails = () => {
  const backUrl = "";
  const toast = useToast();
  const { id } = useParams();
  const {
    data,
    refetch,
    loading: pageLoading,
  } = useFetch(settlement_url + `${id}/`);
  const cardData = [
    {
      label: "Order Amount",
      value: data?.currency_symbol + data?.total_amount_paid_amt,
    },
    {
      label: "Total Charges",
      value: data?.currency_symbol + data?.seller_charges_total,
    },
    {
      label: "Net Payable Amount",
      value: data?.currency_symbol + data?.net_payable_amount,
    },
  ];

  const actnButtons = [
    data?.reconcile_file && {
      title: "Download Invoice",
      bg: "#dbeafd",
      color: "#1b4168",
      Icon: DownloadCloud,
      onClick: () => {
        if (!data?.reconcile_file) return;
        const link = document.createElement("a");
        link.href = data.reconcile_file; // URL to the file
        link.download = "settlement.pdf"; // optional filename
        link.click();
      },
    },
    {
      title:
        data?.is_settled
          ? "Settled"
          : "Mark Settled",
      bg: data?.is_settled ? "#f2f2f2" : "#1b4168",
      color: data?.is_settled ? "" : "#ffffff",
      Icon: CheckIcon,
      onClick: () => {
        if (data.is_settled) return;

        areYouSure(async () => {
          try {
            await api.post(settlement_list_url, { order_id: [data?.id] });
            toast.open("Marked as settled successfully!", "success");
            refetch();
          } catch (error) {
            if (error.response.data.message) {
              toast.open(error.response.data.message, "error");
            } else {
            }
          }
        }, "Are you sure?");
      },
    },
  ];

  const orderData = [
    {
      label: "Order ID",
      value: data?.order_id || "N/A",
    },
    {
      label: "Order Date",
      value: data?.created ? moment(data?.created).format("DD/MM/YYYY") : "N/A",
    },
    {
      label: "Seller Name",
      value: data?.company_name || "N/A",
    },
    {
      label: "Order Status",
      value: data?.action_name || "N/A",
    },
  ];
  const paymentData = [
    {
      label: "Payment Method",
      value: data?.payment_method || "N/A",
    },
    {
      label: "Payment Amount",
      value: data?.currency_symbol + data?.total_amount_paid_amt || "N/A",
    },
    {
      label: "Payment ID(Received by Pentagon)",
      value: data?.payment_id || "N/A",
    },
    {
      label: "Transaction ID(User Transaction)",
      value: "N/A",
    },
  ];
  if (pageLoading) return <Loading />;
  return (
    <div className="recon-settlment-container">
      <BackButton href={backUrl} />
      <h1>Order Details</h1>
      <div className="recon-cards">
        {cardData.map(({ label, value }, i) => (
          <div key={i} className="recon-border recon-card">
            <h3>{label}</h3>
            <p>{value || 0}</p>
          </div>
        ))}
      </div>
      <div className="btn-wrapper">
        {actnButtons.filter(v => v).map(
          ({ title, bg, color, Icon, onClick = () => { } }, index) => (
            <div
              key={index}
              style={{
                backgroundColor: bg,
                color: color,
              }}
              className="actn-btn"
              onClick={onClick}
            >
              <Icon size={15} /> {title}
            </div>
          )
        )}
      </div>

      <div className="info-cards">
        <div className="info-card recon-border">
          <p className="title">Order Information</p>
          {orderData.map(({ label, value }, index) => (
            <div key={index}>
              <p className="label">{label}</p>
              <p className="value">{value}</p>
            </div>
          ))}
        </div>
        <div className="info-card recon-border">
          <p className="title">Payment Information</p>

          {paymentData.map(({ label, value }, index) => (
            <div key={index}>
              <p className="label">{label}</p>
              <p className="value">{value}</p>
            </div>
          ))}
        </div>
      </div>
      {data?.seller_charges.length > 0 && <div className="recon-border">
        <div className="charges-wrapper">
          <p className="title" style={{ margin: 0 }}>
            Charges Breakdown
          </p>
        </div>
        {data?.seller_charges?.map((d, i) => (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p>{d?.charge_name || "Charge Name"}</p>
            <div style={{ display: "flex", gap: "15px" }}>
              {(d?.percent_or_fix === "FIX" ||
                d?.percent_or_fix === "BOTH") && (
                  <p>
                    {d?.country_currency_symbol}
                    {d?.price_value || 0}
                  </p>
                )}
              {d?.percent_or_fix === "BOTH" && <span>or</span>}
              {(d?.percent_or_fix === "PERCENT" ||
                d?.percent_or_fix === "BOTH") && (
                  <p>{d?.charge_percent || 0}%</p>
                )}
            </div>
          </div>
        ))}
      </div>}
    </div>
  );
};

export default SettleOrderDetails;
